<template>
  <section>
    <ul>
      <li v-for="(model, index) in models">
        <h4>Question {{index+1}} of {{models.length}}</h4>
        <p v-html="model.question.question" class="question"></p>
        <radio-group :options="model.question.options" :name="'comp'+index" v-model="model.response" @input="save(model)" :disabled="!respondable">
          <span :class="['bullet', {correct: option.correct, incorrect: !option.correct}]" v-for="(option, index) in model.question.options" :slot="'bullet-'+index" v-if="!respondable && (option.correct || option.response==model.response)">
            <sprite v-if="(option.correct)" name="iconCheck" />
            <sprite v-else="(!option.correct)" name="iconClose" />
          </span>
          <div v-for="(option, index) in model.question.options" :slot="'lower-'+index" v-if="!respondable" class="explanation">
            {{ option.explanation }}
          </div>
        </radio-group>
      </li>
    </ul>
  </section>
</template>

<script>

  export default {
    name: 'Comprehension',
    props: {
      models: {
        type: Array,
        required: true
      },
      respondable: {
        type: Boolean
      }
    },
    methods: {
      save (model) {
        model.DSSave()
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import "~globals";

  ul {
    @include list-style-reset;
  }

  li + li {
    margin-top:3rem;
  }

  h4 {
    @include font-size(medium, $headline:true);
    margin-bottom:1rem;
  }

  .bullet {
    @include bullet();
  }

  .question {
    margin-bottom:2rem;
  }

  .explanation {
    font-size:90%; font-style:italic; color:$color-gray-darkest;
  }

</style>



// WEBPACK FOOTER //
// src/components/_global/comprehension.vue